import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  around: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    border: "1px solid #C4C5D6",
    borderRadius: "16px",
    paddingLeft: "8px",
    paddingRight: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  arround2: {
    borderRadius: "24px",
    width: "100%",
    height: "320px",
  },
  around3: {
    border: "1px solid #C4C5D6",
    borderRadius: "16px",
    paddingLeft: "8px",
    paddingRight: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
}));

export default useStyles;
